import { storyblokEditable } from "@storyblok/react";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { useRouter } from "next/router";
import { useCurrentUser } from "@hooks/use-current-user";
import Link from "@components/core/Link";
import ImageFadeIn from "@components/core/ImageFadeIn";

function LargeBannerImage({ blok }) {
  const router = useRouter();
  const user = useCurrentUser();
  const userGroup = user?.user_group;

  function sendTrackerData() {
    const defaultEventData = {
      tracking_name: "homeLargeBannerImage",
      page: router.asPath,
      link: blok.link?.url,
      user_group: userGroup,
    };

    ahoy("$click", defaultEventData);
    analytics.track("$click", defaultEventData);
  }

  if (!blok) return null;

  return (
    <section
      key={blok._uid}
      {...storyblokEditable(blok)}
      className="storyblok-home-section"
    >
      <Link
        href={blok.link?.url}
        onClick={() => sendTrackerData()}
      >
        <ImageFadeIn
          className="large-banner-image-desktop"
          src={blok.background_image_desktop.filename}
        />
        <ImageFadeIn
          className="large-banner-image-mobile"
          src={blok.background_image_mobile.filename}
        />
      </Link>
    </section>
  );
}

export default LargeBannerImage;
